export default __webpack_public_path__ + "static/media/currency-icon.63757b47.svg";